import Logger from './logger'

export default new Logger()
